import React from "react";
var ChevronUp = function ChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.75 17.939a.752.752 0 01-.53-1.281L10.94 5.94c.283-.284.659-.44 1.059-.44.401 0 .777.156 1.06.438l10.721 10.72a.752.752 0 01-.53 1.281.743.743 0 01-.53-.22L12 7 1.28 17.719a.743.743 0 01-.53.22z"
  }));
};
ChevronUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
import createIconComponent from '../createIconComponent';
export const ChevronUpIcon = createIconComponent(ChevronUp, 'ChevronUp');